import axiosInstance from "../../services/API";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Function to get the list of friends to share main home post
export const searchFriends = createAsyncThunk("searchFriends", async (query) => {
    const response = await axiosInstance.get(`/search/share/search/?q=${query}`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

// Function to get recent search results for sharing main home post
export const getRecentSearch = createAsyncThunk("getRecentSearch", async () => {
    const response = await axiosInstance.get(`/search/share/recent/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

// Function to share a home post through message
export const shareVideoThoughMessage = createAsyncThunk("shareVideoThoughMessage", async (data) => {
    const response = await axiosInstance.post(`/messages/share-post/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

// Function to get recent friend list for sharing main home post
export const getRecentFriendList = createAsyncThunk("getRecentFriendList", async () => {
    const response = await axiosInstance.get(`/messages/friends/recent/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});
// Function to share a group profile through message
export const groupProfileShareThoughMessage = createAsyncThunk("groupProfileShareThoughMessage", async (data) => {
    const response = await axiosInstance.post(`/messages/share-group/`, data);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const ShareSlice = createSlice({
    name: "ShareSlice",
    initialState: {
        searchData: [],
        recentSearchData: [],
        shareVideoData: null,
        recentFriends: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // Search friends for sharing main home post
        builder.addCase(searchFriends.pending, (state) => {
            state.loading = true;
            state.searchData = [];
        });
        builder.addCase(searchFriends.fulfilled, (state, action) => {
            state.searchData = action.payload;
            state.loading = false;
        });
        builder.addCase(searchFriends.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Recent search results for sharing main home post
        builder.addCase(getRecentSearch.pending, (state) => {
            state.loading = true;
            state.recentSearchData = [];
        });
        builder.addCase(getRecentSearch.fulfilled, (state, action) => {
            state.recentSearchData = action.payload;
            state.loading = false;
        });
        builder.addCase(getRecentSearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Share home post through message
        builder.addCase(shareVideoThoughMessage.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(shareVideoThoughMessage.fulfilled, (state, action) => {
            state.loading = false;
            state.shareVideoData = action.payload;
            state.error = null;
        });
        builder.addCase(shareVideoThoughMessage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Get recent friend list for sharing main home post
        builder.addCase(getRecentFriendList.pending, (state) => {
            state.loading = true;
            state.recentFriends = [];
        });
        builder.addCase(getRecentFriendList.fulfilled, (state, action) => {
            state.recentFriends = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getRecentFriendList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default ShareSlice.reducer;